import { createApp } from 'vue'
import config from 'devextreme/core/config'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { licenseKey } from './devextreme-license.js'

import './styles/brand.css'
import './styles/global.css'
import './assets/fonts.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import './composables/useTheme.js'

config({ licenseKey })

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')
